import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tshirtSizesAPI } from '@/services/tshirtSizesApi';
import { queryKeys } from './queryKeys';

export function useTshirtSizes(raceId?: any, raceTypeId?: any) {
  return useQuery({
    queryKey: queryKeys.tshirtSizes.all(raceId, raceTypeId),
    queryFn: () => tshirtSizesAPI.getTshirtSizes(raceId, raceTypeId),
    enabled: !!raceId,
  });
}

export function useCreateTshirtSize(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => tshirtSizesAPI.createTshirtSize(raceId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.tshirtSizes._def }),
  });
}

export function useUpdateTshirtSize() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => tshirtSizesAPI.updateTshirtSize(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.tshirtSizes._def }),
  });
}

export function useDeleteTshirtSize() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => tshirtSizesAPI.deleteTshirtSize(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.tshirtSizes._def }),
  });
}
